module.exports = __webpack_public_path__ + "img/app_code3.416de32a.png";